import { gql } from '@apollo/client'

export const GET_TOTAL_ENTRIES = gql`
  query getTotalEntries($input: GetTheatricalPresalesSummaryInput!) {
    getTheatricalPresalesSummary(input: $input) {
      sweepstakesSummary {
        totalEntries
      }
    }
  }
`
